<template>
  <main class="relative min-h-screen font-roboto overflow-hidden">
    <img src="../../assets/images/login_bg.jpg" alt=""
      class="absolute top-0 left-0 w-full h-screen object-cover -z-10 mobile:scale-[1.5] tablet:scale-[1.4] laptop:scale-100">
    <div
      class="relative tablet:absolute z-10 top-0 right-0 tablet:py-2 mobile:overflow-y-auto h-screen mobile:justify-start tablet:justify-center desktop:justify-start largeDesktop:!h-screen mobile:px-[25px] tablet:px-20 desktop:px-[40px] largeDesktop:px-12 flex flex-col items-center justify-center mobile:w-full largeDesktop:w-[700px] laptop:w-[550px] bg-[#2359a8f0] laptop:bg-[#2459A8]">
      <div class="mobile:mt-10 tablet:mt-0 flex items-center justify-start w-full mobile:gap-2 tablet:gap-3">
        <img src="../../assets/images/MyHappy-Logo.png" class="w-[165px] tablet:w-[221px] object-cover"
          alt="fyxify Logo">
        <!-- <h4 class="m-0 font-roboto mobile:text-lg tablet:text-xl desktop:2xl text-white">Create New Account</h4> -->
      </div>
      <div class="flex items-center justify-start mobile:mt-[25px] mobile:mb-[20px] tablet:my-[30px] relative">
        <div
          class="relative rounded-full overflow-hidden mobile:w-20 mobile:h-20 tablet:w-[100px] tablet:h-[100px] laptop:w-[120px] laptop:h-[120px] shadow-[0px_4px_10px_0px_#00000040] bg-white cursor-pointer"
          @click="triggerFileUpload">
          <img :src="imageSrc || require('@/assets/images/register-camera-icon.png')" alt="Profile"
            class="object-contain w-full h-full" />
          <input type="file" accept="image/*" ref="fileInput" @change="handleFileChange" class="hidden" />
        </div>
        <button v-if="imageSrc" @click="removeClicked" type="button"
          class="mobile:w-[20px] mobile:h-[20px] laptop:h-[24px] laptop:w-[24px] object-contain absolute mobile:left-[30px] laptop:left-[50px] -bottom-2.5">
          <img src="../../assets/images/remove-profile.png" class="img-fluid" alt="">
        </button>
      </div>
      <div class="mobile:mb-[30px] tablet:mt-0 mobile:flex mobile:flex-col tablet:grid tablet:grid-cols-2 w-full mobile:gap-[15px] laptop:gap-[20px]">
        <div>
          <label for="firstName" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">First Name: <span
              class="text-red-600">*</span></label>
          <inputComponent ref="firstNameRef" v-model="first_name" name="firstName" required
            errorClass="!text-customYellow-100" placeholder="Enter First Name"
            customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
        </div>
        <div>
          <label for="lastName" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Last Name: <span
              class="text-red-600">*</span></label>
          <inputComponent ref="lastNameRef" v-model="last_name" name="lastName" required
            errorClass="!text-customYellow-100" placeholder="Enter Last Name"
            customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
        </div>
        <div>
          <label for="email" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Email: <span
              class="text-red-600">*</span></label>
          <inputComponent ref="emailRef" v-model="email" name="email" required :regex="$constants.EMAIL_REGEX"
            errorClass="!text-customYellow-100" error-message="Please enter a valid email address"
            placeholder="Enter Email"
            customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
        </div>
        <div>
          <label for="phoneNumber" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Phone: <span
              class="text-red-600">*</span></label>
          <inputComponent ref="phoneRef" v-model="phone" name="phone" required mask="(###) ###-####" type="tel"
            errorClass="!text-customYellow-100" placeholder="Enter Number" error-message="Invalid phone number"
            customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
        </div>
        <div>
          <label for="password" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Password: <span
              class="text-red-600">*</span></label>
          <PasswordInput v-model="password" ref="passwordRef" name="password" required
            :regex="$constants.PASSWORD_REGEX" errorClass="!text-customYellow-100"
            error-message="Minimum 8 characters with uppercase, number & symbol. Emojis and spaces are not allowed."
            placeholder="Enter Password"
            customClass="!text-[16px] mobile:!py-[9px] mobile:!pl-[9px] largeDesktop:!py-[11px] largeDesktop:!pl-[11px] !rounded-[5px] mobile:!pr-[30px] largeDesktop:!pr-[35px]" />
        </div>
        <div>
          <label for="confirmPassword" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Confirm
            Password: <span class="text-red-600">*</span></label>
          <inputComponent v-model="confirmPassword" ref="confirmPasswordRef" name="confirmPassword" type="password"
            required :confirmWith="password" placeholder="Enter Confirm Password" errorClass="!text-customYellow-100"
            error-message="Passwords do not match"
            customClass="!text-[16px] mobile:!py-[9px] mobile:!pl-[9px] largeDesktop:!py-[11px] largeDesktop:!pl-[11px] !rounded-[5px] mobile:!pr-[30px] largeDesktop:!pr-[35px]" />
        </div>
        <div class="col-span-2">
          <label for="companyReferral" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">
            Affiliate Referral:
          </label>
          <div class="relative">
            <inputComponent ref="companyReferral" v-model="company_referal" required name="companyReferral"
              :disabled="loading" errorClass="!text-customYellow-100" placeholder="Affiliate Referral"
              @input="handleInput" customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
            <div v-if="loading" class="absolute right-0 top-0 flex items-center justify-center h-full px-2">
              <svg class="animate-spin h-6 w-6 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
            </div>
          </div>
          <p v-if="isAppiCAlled && !isRefferalFound" class="!text-customYellow-100 text-xs mt-1 mb-0">
            {{ "Invalid Refferal Code" }}</p>
        </div>
        <!-- hidden -->
        <div class="hidden">
          <div
            class="col-span-2 border-2 rounded-full w-max mx-auto mobile:p-1 tablet:p-1 desktop:mt-2 border-[#FE5000]">
            <p class="m-0 mobile:text-sm tablet:text-base text-[#FE5000]">OR</p>
          </div>
          <div class="col-span-2">
            <label for="companyReferral" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Company Name:
              <span class="text-red-600">*</span></label>
            <div class="relative">
              <inputComponent ref="companyName" v-model="company_name" name="companyName" required
                :disabled="isRefferalFound" placeholder="Company Name" />
            </div>
          </div>
          <div class="col-span-2">
            <label for="companyReferral" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Company
              Address:<span class="text-red-600">*</span></label>
            <div class="relative">
              <GoogleAutoComplete v-if="!isRefferalFound" v-model="company_address" placeholder="Address"
                :reset="resetAddress" @place-selected="handlePlace" @address-reset="selectedAddress = null"
                :input-class="'w-full mobile:p-1.5 largeDesktop:p-2 border border-gray-600 text-gray-600 outline-none text-sm'" />
              <inputComponent v-else v-model="company_address" :disabled="isRefferalFound" />
            </div>
            <p v-if="selectedAddress == null && !isRefferalFound && isValidate" class="text-red-500 text-xs mt-1 mb-0">
              {{
                "Please select address." }}</p>
          </div>
        </div>

        <!-- hidden  -->
        <div class="col-span-2 hidden">

          <p class="m-0 text-sm text-justify font-roboto font-normal text-white">By clicking "Submit", you agree to the portyl® <a
              :href="icaUrl ? icaUrl : ''" target="_blank"
              class="cursor-pointer text-sm no-underline text-[#FE5000]">Contractor Agreement </a>and<a
              :href="privacyUrl ? privacyUrl : ''" target="_blank"
              class="cursor-pointer text-sm no-underline text-[#FE5000]"> Privacy Policy </a>
          </p>
          <p class="m-0 text-sm text-justify text-white mt-2">You may receive text messages from fyxify related to your
            account and verification (e.g., 2FA codes or service notifications)</p>

        </div>

        <div class="col-span-2 my-2.5">
          <div class="flex desktop:items-start laptop:items-center mobile:items-start">
            <label class="flex items-start cursor-pointer mt-[3px]">
              <input type="checkbox" v-model="checkbox" class="hidden peer" />
              <span
                class="min-w-7 min-h-7 flex items-center justify-center border-[1px] !border-[#ccc] bg-white rounded-md transition">
                <svg v-if="checkbox == true" class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 20 20">
                  <path d="M5 10.5 8.5 14 15 7.5" />
                </svg>
              </span>
            </label>
            <span class="ml-2 text-xs font-normal text-white text-justify">I would like to receive promotional offers
              and relevant information from fyxify via text message. Message and data rates may apply.</span>
          </div>
        </div>
        <div class="col-span-2">
          <RecaptchaBox @verified="recaptchaVerified" ref="recaptchaRef" />
        </div>
        <!-- <div class="col-span-2">
          <p class="m-0 font-roboto text-sm text-center text-white">By clicking "Submit" you agree to the portyl® <a
              :href="icaUrl ? icaUrl : ''" target="_blank"
              class="cursor-pointer text-sm no-underline text-customYellow-100">Contractor Agreement </a>and<a
              :href="privacyUrl ? privacyUrl : ''" target="_blank"
              class="cursor-pointer text-sm no-underline text-customYellow-100"> Privacy Policy </a>
            </p>
        </div> -->
        <div class="col-span-2">
          <p class="m-0 font-roboto text-sm text-center text-white">By clicking "Submit" you agree to the portyl® <a
              @click="contractorAgreementClicked"
              class="cursor-pointer text-sm no-underline text-customYellow-100">Contractor Agreement </a>and<a
              @click="privacyPolicyClicked" class="cursor-pointer text-sm no-underline text-customYellow-100"> Privacy
              Policy </a>
          </p>
        </div>
        <div class="col-span-2 text-center">
          <button @click="submitClicked" :disabled="loading"
            class="mobile:px-8 mobile:py-1.5 laptop:px-[60px] laptop:py-[10px] rounded-full font-bold text-base tablet:text-lg w-max mx-auto CustomYellowBtn disabled:hover:bg-none disabled:border-[#ffffff7a] disabled:!text-[#ffffff7a] disabled:cursor-not-allowed focus:outline-none "
            type="submit">SUBMIT</button>
          <p class="mt-4 text-sm mb-0 text-center font-roboto font-normal text-white">Aready have an account? <span @click="loginClicked()"
              class="cursor-pointer text-customYellow-100">Login</span> </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import inputComponent from '../../components/partialComponent/inputComponent.vue';
import PasswordInput from '../../components/partialComponent/PasswordInput.vue';
import GoogleAutoComplete from '../../components/partialComponent/GoogleAutoComplete.vue';
import RecaptchaBox from '../../components/partialComponent/recaptchaBox.vue'
import { useToast } from "vue-toastification";
import { mapActions, mapGetters } from "vuex";
const toast = useToast();
export default {
  components: {
    inputComponent,
    PasswordInput,
    GoogleAutoComplete,
    RecaptchaBox
  },
  data() {
    return {
      checkbox: false,
      imageSrc: null,
      imageFile: null,
      phone: null,
      first_name: null,
      last_name: null,
      email: null,
      selectedAddress: null,
      company_address: null,
      company_referal: '',
      company_name: null,
      password: null,
      confirmPassword: null,
      loading: false,
      debounceTimer: null,
      isRefferalFound: false,
      companyRefferalModel: null,
      isAppiCAlled: false,
      isValidate: false,
      recaptchaToken: null,
      icaUrl: null,
      privacyUrl: null,
    };
  },


  computed: {
    ...mapGetters([
      "companyReferalCode",
      "userObject",
      "bootMeUpData",
      // "updatePrivacyPolicyDetails"
    ]),
  },

  watch: {
    companyReferalCode: function (data) {
      this.loading = false
      this.isAppiCAlled = true
      if (this.companyReferalCode.status == true) {
        this.isRefferalFound = true
        this.companyRefferalModel = this.companyReferalCode.body
        this.company_name = this.companyRefferalModel.company_name
        this.company_address = this.companyRefferalModel.company_address
      } else {
        this.companyRefferalModel = null
        this.isRefferalFound = false
        this.selectedAddress = null
        this.company_address = null
        this.company_name = null
      }
    },

    // bootMeUpData: function () {
    //   this.icaUrl = this.bootMeUpData.static_pages['setting.application.static_pages.ica']
    //   this.privacyUrl = this.bootMeUpData.static_pages['setting.application.static_pages.privacy_policy']
    // },

    userObject: function () {

      if (this.userObject != 'undefined') {
        if (this.userObject.user.email_verification == '0') {
          this.saveState()
          this.$router.replace({
            name: 'verification'
          })
        }
      }
    },
  },

  mounted() {
    // const savedData = localStorage.getItem('registerFormData');
    // if (savedData) {
    //   const formData = JSON.parse(savedData);
    //   Object.assign(this, formData);
    // }
    this.getBootMeData({})
    document.body.style.position = '';
    document.body.style.overflow = '';
    document.body.classList.remove('modal-open');
    this.setReferal()
    // this.getPrivacyPolicyDetails()
  },

  beforeUnmount() {
    document.body.style.position = '';
    document.body.style.overflow = '';
  },

  methods: {

    ...mapActions([
      "checkCompanyReferalCode",
      "userRegister",
      "getBootMeData",
      // "getPrivacyPolicyDetails"
    ]),

    setReferal() {
      this.company_referal = this.$route.query.referal ?? ''
      if (!this.$helper.isEmpty(this.company_referal)) {
        this.checkRefferal()
      }
    },

    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      this.imageFile = event.target.files[0];

      if (this.imageFile) {
        const reader = new FileReader();
        reader.onload = e => {
          this.imageSrc = e.target.result;
        };
        reader.readAsDataURL(this.imageFile);
      }
    },


    removeClicked() {
      this.imageSrc = null
      this.$refs.fileInput.value = ''
    },

    resetAddress() {
      this.selectedAddress = null
    },

    handlePlace(data) {
      this.selectedAddress = data
    },

    handleInput() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer
      this.debounceTimer = setTimeout(() => {
        this.checkRefferal()

      }, 1000); // 1200ms delay
    },

    checkRefferal() {
      if (!this.$helper.isEmpty(this.company_referal) || this.company_referal.trim().length > 0) {
        this.loading = true
        this.checkCompanyReferalCode({
          "company_referral": this.company_referal
        });
      } else {
        this.isAppiCAlled = false
      }
    },

    recaptchaVerified(token) {
      this.recaptchaToken = token;
    },


    submitClicked() {

      const refsToValidate = [
        this.$refs.firstNameRef,
        this.$refs.lastNameRef,
        this.$refs.emailRef,
        this.$refs.phoneRef,
        this.$refs.passwordRef,
        this.$refs.confirmPasswordRef,
        this.$refs.companyReferral
      ];
      this.isValidate = true

      let firstInvalidRef = null;


      for (const ref of refsToValidate) {
        if (ref?.validate?.()) {
          if (!firstInvalidRef) firstInvalidRef = ref;
        }
      }

      if (firstInvalidRef) {
        // Scroll to and focus the first invalid field
        firstInvalidRef.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const inputEl = firstInvalidRef.$el.querySelector('input');
        inputEl?.focus();
        return;
      }

      if (this.isAppiCAlled && !this.isRefferalFound) {
        return
      }

      if (!this.recaptchaToken) {
        toast.error("You must verify the reCAPTCHA before continuing.");
        return;
      }

      this.callUserRegister()
    },

    callUserRegister() {

      let formData = new FormData()
      formData.append("first_name", this.first_name)
      formData.append("last_name", this.last_name)
      formData.append("password", this.password)
      formData.append("password_confirmation", this.confirmPassword)
      formData.append("email", this.email.trim())
      formData.append("phone", this.phone)
      formData.append("captcha_token", this.recaptchaToken)
      formData.append("timestamp", (new Date()).getTime())
      formData.append("company_referral", this.company_referal)
      if (this.imageFile) {
        formData.append("image", this.imageFile)
      }
      this.$refs.recaptchaRef.resetCall()
      this.userRegister(formData)

    },

    saveState() {
      const formData = {
        imageSrc: this.imageSrc,
        imageFile: this.imageFile,
        phone: this.phone,
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email.trim(),
        selectedAddress: this.selectedAddress,
        company_address: this.company_address,
        company_referal: this.company_referal,
        company_name: this.company_name,
        password: this.password,
        confirmPassword: this.confirmPassword,
        isRefferalFound: this.isRefferalFound,
        companyRefferalModel: this.companyRefferalModel
      };
      localStorage.setItem('registerFormData', JSON.stringify(formData));
    },

    loginClicked() {
      localStorage.removeItem('registerFormData')
      this.$router.go(-1)
    },

    privacyPolicyClicked() {
      const url = this.$router.resolve({ name: "privacyPolicy" }).href;
      window.open(url, "_blank");
    },

    contractorAgreementClicked() {
      const url = this.$router.resolve({ name: "contractorAgreement" }).href;
      window.open(url, "_blank");
    }

  },

};
</script>
